import type { ReactElement, ReactNode } from 'react'
import { TidalSandboxGlobalToolbar } from '../ui/index.js'
import classes from './grid.module.css'

interface Props {
  top?: ReactElement
  left?: ReactElement
  bottom?: ReactElement
  right?: ReactElement
  children?: ReactNode
}

export function Grid(props: Props) {
  const { children, top, bottom, right, left } = props

  return (
    <div className={classes.grid} data-testid="layout-grid">
      <div className={classes.top} data-id="tidal-sandbox-top">
        <TidalSandboxGlobalToolbar placement="top">{top}</TidalSandboxGlobalToolbar>
      </div>

      <div className={classes.left} data-id="tidal-sandbox-left">
        <TidalSandboxGlobalToolbar placement="left">{left}</TidalSandboxGlobalToolbar>
      </div>

      <div className={classes.bottom} data-id="tidal-sandbox-bottom">
        <TidalSandboxGlobalToolbar placement="bottom">{bottom}</TidalSandboxGlobalToolbar>
      </div>

      <div className={classes.right} data-id="tidal-sandbox-right">
        <TidalSandboxGlobalToolbar placement="right">{right}</TidalSandboxGlobalToolbar>
      </div>

      {children && (
        <div className={classes.content} data-id="tidal-sandbox-content">
          {children}
        </div>
      )}
    </div>
  )
}
